<script>
export default {
    //此处为服务端 API URL
    backendBaseUrl:"https://api.form.comicvalley.cn",
    //backendBaseUrl:"http://127.0.0.1:7001",
    
}

</script>